<template lang="html">
    <div id="storeTourInfo"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <storeTourBar :tags="tags"
                     :title="title"
                     :date="date"
                     :data="dataInfo"
                     :subTitle1="subTitle1"
                     :subTitle2="subTitle2"
                     :inspection_num="inspection_num"
                     :address="address"
                     :btnSave="btnSave"
                     :distributor_grade="distributor_grade"
                     :btnBack="true" :btnRepeal="onoffManager"

                     @btnRepealClick="delInstitutionsVisit"  @btnBackClick="handleBackClick"/>
        <div id="business" style="margin-top: 25px">
            <el-form>
                <el-row>
                    <el-col>
                        <el-form-item label="巡查日期">
                            <el-date-picker
                                    v-model="activity_date"
                                    type="date"
                                    format="yyyy年M月d日"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    disabled
                                    style="width: 25%"
                                    >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <!--                    <el-col>-->
                    <!--                        <el-form-item label="拜访类型">-->
                    <!--                            <el-select v-model="visitType" placeholder="请选择拜访类型" disabled style="width:25%">-->
                    <!--                                <el-option-->
                    <!--                                        v-for="item in options_type"-->
                    <!--                                        :key="item.key"-->
                    <!--                                        :label="item.value1"-->
                    <!--                                        :value="item.key">-->
                    <!--                                </el-option>-->
                    <!--                            </el-select>-->
                    <!--                        </el-form-item>-->
                    <!--                    </el-col>-->
<!--                    <el-col>-->
<!--                        <el-form-item label="拜访目的">-->
<!--                            <el-select v-model="visitPurpose" placeholder="请选择拜访目的" disabled style="width:25%">-->
<!--                                <el-option-->
<!--                                        v-for="item in options_purpose"-->
<!--                                        :key="item.key"-->
<!--                                        :label="item.value1"-->
<!--                                        :value="item.key">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                </el-row>
            </el-form>
        </div>
        <div style="margin-top:0px;">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="库存盘点" name="stockTaking">
                    <stockTaking :data="dataInfo" :onoffManager="onoffManager" v-if="onoffStockTaking"></stockTaking>
                </el-tab-pane>
                <el-tab-pane label="陈列检查" name="displayCheck">
                    <displayCheck :data="dataInfo" :onoffManager="onoffManager" v-if="onoffDisplayCheck"></displayCheck>
                </el-tab-pane>
                <el-tab-pane label="价格核查" name="priceVerification">
                    <priceVerification :data="dataInfo" :onoffManager="onoffManager" v-if="onoffPriceVerification"></priceVerification>
                </el-tab-pane>
                <el-tab-pane label="竞品信息" name="competingInfo">
                    <competingInfo :data="dataInfo" :onoffManager="onoffManager" v-if="onoffCompetingInfo"></competingInfo>
                </el-tab-pane>
                <el-tab-pane label="活动执行" name="activities">
                    <activities :data="dataInfo" :onoffManager="onoffManager" v-if="onoffActivities"></activities>
                </el-tab-pane>
                <el-tab-pane label="赠品/样品" name="gifts">
                    <gifts :data="dataInfo" :onoffManager="onoffManager" v-if="onoffGifts"></gifts>
                </el-tab-pane>
<!--                <el-tab-pane label="店员教育" name="assistantEducation">-->
<!--                    <assistantEducation :data="dataInfo" v-if="onoffAssistantEducation"></assistantEducation>-->
<!--                </el-tab-pane>-->
                <el-tab-pane label="待办事项" name="storeTodo">
                    <storeTodo :data="dataInfo" :onoffManager="onoffManager" v-if="onoffStoreTodo"></storeTodo>
                </el-tab-pane>
            </el-tabs>
        </div>


        <!--        删除-->
        <!--        <el-dialog-->
        <!--                title="提示"-->
        <!--                :visible.sync="dialogVisible"-->
        <!--                width="30%">-->
        <!--            <span>是否确定删除此条商务拜访</span>-->
        <!--            <span slot="footer" class="dialog-footer">-->
        <!--                <el-button type="primary" @click.stop="delInstitutionsVisit" @click="dialogVisible = false">确 定</el-button>-->
        <!--                <el-button @click="dialogVisible = false">取 消</el-button>-->
        <!--            </span>-->
        <!--        </el-dialog>-->
    </div>
</template>

<script>
    import storeTourBar from '../../../components/storeTourBar'
    import displayCheck from './components/displayCheck'
    import stockTaking from './components/stockTaking'
    import competingInfo from './components/competingInfo'
    import priceVerification from './components/priceVerification'
    import activities from './components/activities'
    import gifts from './components/gifts'
    import assistantEducation from './components/assistantEducation'
    import storeTodo from './components/storeTodo'

    import http from '../../../APIService/http'
    import moment from 'moment'
    export default {
        name: "medical",
        data() {
            return {
                id: "",
                loading: false,
                tags: ['辖区事务','门店巡查'],
                activeName: '',
                dialogVisible:false,
                title:'',
                date:'',
                subTitle1:'',
                subTitle2:'',
                data:{},
                address:'',
                activity_date:'',
                addTodo:{},
                options_purpose:[],
                options_type:[],
                visitType:'',
                visitPurpose:'',
                distributor_grade:'',
                inspection_num:'',
                onoffManager:true,
                disabled:false,
                btnSave:false,
                account_id:'',
                dataInfo:{},
                onoffStockTaking:false,
                onoffDisplayCheck:false,
                onoffPriceVerification:false,
                onoffCompetingInfo:false,
                onoffActivities:false,
                onoffGifts:false,
                onoffAssistantEducation:false,
                onoffStoreTodo:false,
            }
        },
        components: {
            storeTourBar,
            stockTaking,
            displayCheck,
            competingInfo,
            priceVerification,
            activities,
            gifts,
            assistantEducation,
            storeTodo
            // Upload
        },
        created () {
            let condition = localStorage.getItem('condition')
            let data = JSON.parse(condition)
            if((this.$route.params.created_by === this.$store.getters.getUser.user_id) || (data.created_by ===
                this.$store.getters.getUser.user_id) ){
                this.disabled = false
            }else{
                this.disabled = true
            }
        },
        mounted () {
            // document.getElementById('main').scrollTo(0, 0)
            if(Object.keys(this.$route.params).length === 0){
                let condition = localStorage.getItem('condition')
                this.status = 'INFO';
                // console.log(condition)
                this.data = JSON.parse(condition)
                if (!this.data.distributor_id){
                    this.data.distributor_id = this.data.activity_id
                }
                if (this.data.distributor_name) {
                    this.title = this.data.distributor_name;
                }else {
                    this.title = this.data.title
                }
                this.addTodo.institution_name = this.title;
                this.date = this.data.activity_date;
                if(this.data.checkin_time){
                    this.subTitle1 = this.data.checkin_time
                }else{
                    this.subTitle1 = '尚未签入'
                }
                if(this.data.checkout_time){
                    this.subTitle2 = this.data.checkout_time
                }else{
                    this.subTitle2 = '尚未签出'
                }
                this.init()
            }else {

                this.status = 'INFO';
                this.data = this.$route.params;
                if (!this.data.distributor_id){
                    this.data.distributor_id = this.data.activity_id
                }
                if (this.data.distributor_name) {
                    this.title = this.data.distributor_name;
                }else {
                    this.title = this.data.title
                }
                this.addTodo.institution_name = this.title;
                this.date = this.data.activity_date;
                if(this.data.checkin_time){
                    this.subTitle1 = this.data.checkin_time
                }else{
                    this.subTitle1 = '尚未签入'
                }
                if(this.data.checkout_time){
                    this.subTitle2 = this.data.checkout_time
                }else{
                    this.subTitle2 = '尚未签出'
                }
                this.init()
            }
            let user = this.$store.getters.getUser
            if (user.role !== 'staff' && this.$route.params.created_by !== user.user_id) {
                this.onoffManager =false
            }
        },

        methods: {
            handleClick(i){
                if (i.name === 'stockTaking'){

                }else if (i.name === 'displayCheck'){
                    this.onoffDisplayCheck = true
                } else if (i.name === 'priceVerification') {
                    this.onoffPriceVerification = true
                }else if (i.name === 'competingInfo') {
                    this.onoffCompetingInfo = true
                }else if (i.name === 'activities') {
                    this.onoffActivities = true
                }else if (i.name === 'gifts') {
                    this.onoffGifts = true
                }else if (i.name === 'assistantEducation') {
                    this.onoffAssistantEducation = true
                }else if (i.name === 'storeTodo') {
                    this.onoffStoreTodo = true
                }
            },
            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    var str = this.data.activity_date;
                    var approvedates = str.replace(/[年月]/g,"-");
                    var date = approvedates.replace(/[日]/,"");
                    // var year = str.split('')[0]+str.split('')[1]+str.split('')[2]+str.split('')[3];
                    // var month = str.split('')[5]+str.split('')[6];
                    // var day = str.split('')[8]+str.split('')[9];
                    // let date = (year+'-'+month+'-'+day)
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        store_id : this.data.store_id?this.data.store_id:this.data.institution_id,
                        activity_id:this.data.activity_id,
                        date : moment(date).format('YYYY-MM-DD')
                    }
                    await http.post('/wapi/StoreTour/getStoreInspectionInfo',data).then(res=>{
                        if (res.success === true){
                            this.dataInfo = res.data.infoObj
                            this.activity_date = this.dataInfo.activity_date
                            this.activeName = 'stockTaking'
                            this.onoffStockTaking = true
                            // // console.log(res)
                            // this.visitPurpose = res.data.infoObj.visitPurpose
                            // this.visitType = res.data.infoObj.visitType
                            // this.distributor_grade = res.data.infoObj.distributorObj.distributor_grade
                            // this.address = res.data.infoObj.distributorObj.address
                            // this.inspection_num = res.data.infoObj.distributorObj.inspection_num
                            // this.account_id = res.data.infoObj.distributorObj.account_id
                        }else {
                            this.activeName = 'stockTaking'
                            this.onoffStockTaking = true
                        }

                        if(res.data.infoObj.isClosed=='T'){
                            this.onoffManager=false
                        }

                    })
                    // this.getDistributorTypeList();
                    // this.getPurposeVisitList();
                    // this.getCheckListById();
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            // 获取拜访类型
            async getDistributorTypeList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                    }
                    // await http.post('/wapi/Business/getDistributorTypeList',data).then(res=>{
                    //
                    //     this.options_type = res.data
                    // })
                    loading.close()
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            // 获取拜访目的
            async getPurposeVisitList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                    }
                    // await http.post('/wapi/Business/getPurposeVisitList',data).then(res=>{
                    //     if(res.success == true){
                    //         this.options_purpose = res.data
                    //     }
                    //
                    // })
                    loading.close()
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            handleBackClick(){
                this.$router.go(-1)
            },
            handleRepealClick(){
                this.dialogVisible = true
            },
            async delInstitutionsVisit(){

                this.$confirm('确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try{

                        let data={
                            tenant_id:this.$store.getters.getUser.tenant_id,
                            user_id:this.$store.getters.getUser.user_id,
                            activity_id : this.dataInfo.activity_id
                        }
                        await http.post('/wapi/StoreTour/deleteStoreInspection',data).then(res=>{
                            if(res.success === true){
                                this.$router.go(-1)
                                this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                })
                            }
                        })
                    }catch (e) {
                        return e
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //获取签到
            async getCheckListById(){
                var str = this.$route.params.activity_date;
                var year = str.split('')[0]+str.split('')[1]+str.split('')[2]+str.split('')[3];
                var month = str.split('')[5]+str.split('')[6];
                var day = str.split('')[8]+str.split('')[9];
                let date = (year+'-'+month+'-'+day)
                let data ={
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    id :this.$route.params.activity_id,
                    user_id : this.$route.params.created_by,
                    date : date
                }

                // await http.post('/wapi/Conference/getCheckListById',data).then(res=>{
                //     // console.log(res.data,888)
                // })
            },














        }
    }
</script>

<style scoped>
    /*#businessDetails {*/
    /*    background: #fff;*/
    /*    padding: 0px 50px;*/
    /*    height: 100%;*/
    /*    box-sizing: border-box;*/
    /*}*/
    #businessDetails >>>.el-form-item{
        margin-top: 15px;
        margin-bottom: 0px;
    }
    #business >>>.el-form-item__label{
        font-size: 16px;
        color: #000000;
        padding-left: 0px;
        text-align: left;
        padding-right: 40px;
        font-weight: bold;
    }
    #waitList >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    #waitList >>>.el-form-item{
        margin-top: 0px;
    }
    #backlog >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
        margin-left: 20px;
    }
    #back >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: right;
        font-weight: bold;
    }
    #storeTourInfo >>>.el-tag.el-tag--info{
        background: #FF9901;
        color: #FFFFFF;
        border: none;
    }
    #storeTourInfo >>>.el-tag.el-tag--info .el-tag__close{
        display: none;
    }
    #storeTourInfo >>> .el-dialog__body{
        padding-top: 0px;
    }

</style>




// WEBPACK FOOTER //
// src/pages/calendar/components/storeTourInfo.vue